<template>
  <div>
    <template v-for="(item, index) in settings">
      <basic-setting v-if="typeof item === 'string' || (item.type === 'basic' && enable(item))" :config="item" />
      <sub-collapse-setting
        v-else-if="item.type === 'subCollapse' && enable(item)"
        :settings="item.settings"
        :title="item.title"
        :tips="item.tips"
      />
      <block-setting v-else-if="item.type === 'block' && enable(item)" :settings="item.settings" />
      <collapse-setting
        v-else-if="item.type === 'collapse' && enable(item)"
        :initStatus="item.initStatus"
        :settings="item.settings"
        :title="item.title"
      />
    </template>
  </div>
</template>
<script>
import blockSetting from "./block-setting.vue"
import basicSetting from "./basic-setting.vue"
import subCollapseSetting from "./sub-collapse-setting.vue"
import collapseSetting from "./collapse-setting.vue"
export default {
  components: {
    basicSetting,
    blockSetting,
    subCollapseSetting,
    collapseSetting
  },
  inject: ["configData", "configs", "mergedConfigData"],
  props: {
    settings: Array
  },
  computed: {
    enable() {
      return function (config) {
        if (config.enable) {
          return config.enable(this.mergedBasicConfigData)
        }
        return true
      }
    },
    basicConfigData() {
      return this.configData()
    },
    mergedBasicConfigData() {
      return this.mergedConfigData()
    }
  }
}
</script>
